import { createStore } from 'redux';

import globalState from './reducers/globalStateReducer'

//const store = createStore(login, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), applyMiddleware(thunk)) // [, rest of middlewares]
export default createStore(globalState)